import React, {useContext, useEffect, useState} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  openSource,
  blogSection,
  talkSection,
  achievementSection,
  resumeSection
} from "../../portfolio";

function Header() {
  const {isDark} = useContext(StyleContext);
  const viewExperience = workExperiences.display;
  const viewOpenSource = openSource.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;
  const viewBlog = blogSection.display;
  const viewTalks = talkSection.display;
  const viewResume = resumeSection.display;
  const [activeSection, setActiveSection] = useState("");

  const navSections = [
    viewSkills && "skills",
    viewExperience && "experience",
    viewOpenSource && "opensource",
    viewAchievement && "achievements",
    viewBlog && "blogs",
    viewTalks && "talks",
    "contact"
  ].filter(Boolean);

  useEffect(() => {
    const updateActiveSection = () => {
      const marker = 240;
      let current = "";

      navSections.forEach(id => {
        const element = document.getElementById(id);
        if (!element) {
          return;
        }
        if (element.getBoundingClientRect().top <= marker) {
          current = id;
        }
      });

      setActiveSection(current);
    };

    updateActiveSection();
    window.addEventListener("scroll", updateActiveSection, {passive: true});
    return () => window.removeEventListener("scroll", updateActiveSection);
    // navSections is derived from static portfolio flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeMenu = () => {
    const menuButton = document.getElementById("menu-btn");
    if (menuButton) {
      menuButton.checked = false;
    }
  };

  const navClass = sectionId =>
    activeSection === sectionId ? "active-nav-link" : undefined;

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {viewSkills && (
            <li>
              <a
                href="#skills"
                className={navClass("skills")}
                onClick={closeMenu}
              >
                Skills
              </a>
            </li>
          )}
          {viewExperience && (
            <li>
              <a
                href="#experience"
                className={navClass("experience")}
                onClick={closeMenu}
              >
                Work Experiences
              </a>
            </li>
          )}
          {viewOpenSource && (
            <li>
              <a
                href="#opensource"
                className={navClass("opensource")}
                onClick={closeMenu}
              >
                Open Source
              </a>
            </li>
          )}
          {viewAchievement && (
            <li>
              <a
                href="#achievements"
                className={navClass("achievements")}
                onClick={closeMenu}
              >
                Achievements
              </a>
            </li>
          )}
          {viewBlog && (
            <li>
              <a
                href="#blogs"
                className={navClass("blogs")}
                onClick={closeMenu}
              >
                Blogs
              </a>
            </li>
          )}
          {viewTalks && (
            <li>
              <a
                href="#talks"
                className={navClass("talks")}
                onClick={closeMenu}
              >
                Talks
              </a>
            </li>
          )}
          {viewResume && (
            <li>
              <a
                href={greeting.resumeLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Resume
              </a>
            </li>
          )}
          <li>
            <a
              href="#contact"
              className={navClass("contact")}
              onClick={closeMenu}
            >
              Contact
            </a>
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
